<template>
  <mobile-bandwidth v-if="isMobile" />
  <desktop-bandwidth v-else />
</template>

<script>
  import { isMobile } from 'mobile-device-detect'
  import MobileBandwidth from '../../mobile/test/Bandwidth'
  import DesktopBandwidth from '../../desktop/test/Bandwidth'

  export default {
    name: 'common-bandwidth',
    components: {
      'mobile-bandwidth': MobileBandwidth,
      'desktop-bandwidth': DesktopBandwidth
    },
    data () {
      return {
        isMobile
      }
    }
  }
</script>
